import Geolocation from 'ol/Geolocation';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style';
import { fromLonLat } from 'ol/proj';

const geolocation = new Geolocation({
  trackingOptions: {
    enableHighAccuracy: true,
  },
});

const pulseStyle = new Style({
  image: new CircleStyle({
    radius: 6,
    fill: new Fill({
      color: 'rgba(0, 0, 255, 0.5)',
    }),
    stroke: new Stroke({
      color: 'blue',
      width: 2,
    }),
  }),
});
const pulseLayer = new VectorLayer({
  source: new VectorSource({
    features: [new Feature()],
  }),
  style: pulseStyle,
});

const startTrackPosition = (map) => {
  geolocation.setTracking(true);

  geolocation.on('change:position', () => {
    const coordinates = geolocation.getPosition();
    const accuracy = geolocation.getAccuracy();
    const positionFeature = new Feature({
      geometry: new Point(fromLonLat(coordinates, 'EPSG:32637')),
    });
    pulseLayer.getSource().clear();
    pulseLayer.getSource().addFeature(positionFeature);
    map.getView().fit(positionFeature.getGeometry(), {
      maxZoom: 18,
      duration: 500,
    });
  });

  map.addLayer(pulseLayer);
};

const stopTrackPosition = () => {
  geolocation.setTracking(false);
  pulseLayer.getSource().clear();
};

export { startTrackPosition, stopTrackPosition };
